const Host = () => import('../views/pages/host/host.vue')
const HostLogin = () => import('../views/pages/host/host-login/host-login.vue') // 展商登录页
const HostLoginAlogin = () =>
  import('../views/pages/host/host-login/components/alogin.vue') // 密码登录
const HostLayout = () =>
  import('../views/pages/host/host-layout/host-layout.vue') // 展商布局页
const HostHome = () => import('../views/pages/host/host-home/host-home.vue') // 展商注册页

// 项目管理
const HostProject = () =>
  import('../views/pages/host/host-project/host-project.vue') // 项目管理
// 展会设置
const set = () => import('../views/pages/host/set/set.vue') // 展会设置
const HostSet = () => import('../views/pages/host/set/host-set/host-set.vue') // 展会设置
const HostSetOnlineRegistration = () => import('../views/pages/host/set/host-set/host-set-onlineRegistration.vue') // 网上报名设置
// 管理-展商
const HostEx = () => import('../views/pages/host/host-ex/host-ex.vue') // 展商管理
const HostApplyEx = () =>
  import('../views/pages/host/host-ex/host-ex-applyEx/host-ex-applyEx.vue') // 参展申请管理
const HostActivitySet = () =>
  import('../views/pages/host/host-ex/host-activitySet/index.vue') // 活动设置
const HostActivityDetail = () =>
  import('../views/pages/host/host-ex/host-activitySet/detail.vue') // 活动设置
const HostActivityList = () =>
  import('../views/pages/host/host-ex/host-activitySet/list.vue') // 活动设置
const hostApplyExport = () =>
  import('../views/pages/host/set/host-set/host-apply-export.vue') // 参展申请管理

const HostOperationLog = () =>
  import('../views/pages/host/host-ex/host-operationLog/host-operationLog.vue') //统计管理
//展位预定信息

const hostRouter = [
  {
    path: '/host',
    redirect: '/host/index/home',
    name: 'host',
    component: Host,
    children: [
      {
        path: 'index',
        name: 'HostLayout',
        component: HostLayout,
        children: [
          { path: 'home', name: 'home', component: HostHome },
          {
            path: 'set',
            redirect: '/host/index/set/base',
            name: 'set',
            component: set,
            children: [{ path: 'base', name: 'base', component: HostSet }]
          },
          {
            path: 'set',
              redirect: '/host/index/set/onlineRegistration',
            name: 'set',
            component: set,
              children: [{ path: 'onlineRegistration', name: 'onlineRegistration', component: HostSetOnlineRegistration }]
          },
          {
            path: 'ex',
            redirect: '/host/index/ex/list',
            name: 'supply',
            component: HostEx,
            children: [
              { path: 'applyEx', name: 'applyEx', component: HostApplyEx },
              { path: 'export', name: 'export', component: hostApplyExport },
              {
                path: 'hostOperationLog',
                name: 'hostOperationLog',
                component: HostOperationLog
              },
              {
                path: 'activitySet',
                name: 'activitySet',
                component: HostActivitySet
              },
              {
                path: 'activityDetail',
                name: 'activityDetail',
                component: HostActivityDetail
              },
              {
                path: 'activityList',
                name: 'activityList',
                component: HostActivityList
              }
            ]
          }
        ]
      },
      {
        path: 'project',
        name: 'host-project',
        component: HostProject
      },
      {
        path: 'login',
        redirect: '/host/login/alogin',
        name: 'host-register',
        component: HostLogin,
        meta: { requireAuth: false },
        children: [
          {
            path: 'alogin',
            name: 'alogin',
            component: HostLoginAlogin,
            meta: { requireAuth: false }
          }
        ]
      }
    ]
  }
]

export { hostRouter }
